export const DA_REPORT_AVAILABLE_DATE = '2022-02';
